// extracted by mini-css-extract-plugin
export default {"column":"ListPractitioners_column__lJobs","wrapper":"ListPractitioners_wrapper__4J4jc","practitionersWrapper":"ListPractitioners_practitionersWrapper__qIU3b"};